import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, ShieldCheck, ArrowLeft } from "lucide-react";
import LeadFormInline from "../components/LeadFormInline";

const HERO_BG = "https://images.pexels.com/photos/31602311/pexels-photo-31602311.jpeg";

/**
 * Dedicated "Request a Cash Offer" page — the ONLY page on the site that
 * collects a phone number. Kept isolated so the LeadConnector chat widget
 * (which handles SMS) can never share a page with a phone-collection form.
 */
export default function RequestOffer() {
  const [sp] = useSearchParams();
  const src = sp.get("src") || "request-offer";
  const situation = sp.get("situation") || undefined;

  return (
    <section
      className="relative overflow-hidden min-h-[calc(100vh-64px)]"
      data-testid="request-offer-page"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
        aria-hidden
      />
      <div className="absolute inset-0 hero-overlay" aria-hidden />

      <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-14 sm:py-20 grid gap-10 lg:grid-cols-12 items-start">
        <div className="lg:col-span-6 text-white">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/80 hover:text-white text-sm mb-6"
            data-testid="back-to-home"
          >
            <ArrowLeft size={16} /> Back to home
          </Link>
          <div className="inline-flex items-center gap-2 bg-money/90 text-white text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-5">
            <ShieldCheck size={14} /> Cash offer in 24 hours
          </div>
          <h1
            className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
            data-testid="request-offer-headline"
          >
            Request Your Cash Offer
          </h1>
          <p className="mt-5 text-lg sm:text-xl text-white/85 max-w-xl">
            Tell us about the house — takes two minutes. We'll call within 24 hours with a firm, no-obligation offer.
          </p>
          <ul className="mt-7 space-y-2 text-white/95 max-w-md">
            {[
              "No fees, no commissions, no repairs",
              "We pay all standard closing costs",
              "Flexible closing timeline — you pick the date",
              "Any condition, any situation",
            ].map((b) => (
              <li key={b} className="flex items-start gap-2">
                <CheckCircle2 size={20} className="text-money shrink-0 mt-1" /> {b}
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-6">
          <LeadFormInline sourcePage={src} situation={situation} />
        </div>
      </div>
    </section>
  );
}
